export const CHARTING_PRICE_SERIES_TYPES = ['bars', 'area'];

export function normalizeChartingPriceSeriesType(value) {
    return CHARTING_PRICE_SERIES_TYPES.includes(value) ? value : 'bars';
}
